module.exports = __webpack_public_path__ + "img/vip_yinlian.0c91a3d9.png";